export const site = {
  name: "0001(ゼロイチ)",
  description:
    "関西の謎解きクリエイター3人による制作チーム『0001(ゼロイチ)』。謎解きやボードゲームなど、様々な形でひらめきの楽しさをお届けしています。",
  siteUrl: "https://www.zeroichinazo.com", // 公開URLに合わせて変更
  twitterSite: "@0001_nazo",
  ogImage: "/assets/og/og_zeroichi.png",
  favicon: "/favicon.ico",
  themeColor: "#ffffff",
  titleTemplate: "%s | 0001(ゼロイチ)",
  /**
   * Google アナリティクスのスクリプトURL（例: https://www.googletagmanager.com/gtag/js?id=G-XXXXXXX）
   * 空文字のままなら未使用として扱う想定
   */
  googleAnalyticsUrl: "",
  /**
   * Google サーチコンソールのプロパティURL（計測対象のサイトURL）。
   * 例: https://example.com/ （必要に応じて設定）
   */
  searchConsoleUrl: "",
};
